import { Integration_Handler_Names_Enum } from '@main/graphql/types.generated';
import { patternFilterSchema } from '@main/shared/utils';
import { z } from 'zod/v4';

import { IntegrationConfig } from '../../../../../../lib';
import { CrowdstrikeService } from '../../service';

export type RemovableMediaConfig = typeof RemovableMediaConfig._.Config;

export const RemovableMediaConfig = IntegrationConfig.make({
  service: CrowdstrikeService,
  name: Integration_Handler_Names_Enum.RemovableMedia,
  configSchema: z.object({
    requiredPolicyIds: z.array(z.string().min(1)).optional(),
    hostPatternFilter: patternFilterSchema.optional(),
  }),
});
